import { Record, List } from "immutable";
import { IProductOptionData } from "common/records/ProductOption";
import { IProductToOptionGroupLinkData } from "common/records/ProductToOptionGroupLink";
import { Nullable } from "common/records";

export const productOptionGroupFromJSON = (json: Partial<IProductOptionGroupData>): ProductOptionGroupRecord => {
  const recordData: IProductOptionGroupRecord = { ...(json as any) };

  if (json.options) {
    recordData.option_ids = List(json.options.map((opt) => opt.id));
  }

  if (json.product_ids) {
    recordData.product_ids = List(json.product_ids);
  }

  if (!json.match_id && json.uuid !== undefined) {
    recordData.match_id = json.uuid;
  }

  return new ProductOptionGroupRecord(recordData);
};

export interface IProductOptionGroupData {
  id: number;
  matched: IProductOptionGroupData[];
  uuid: string;
  match_id: string;
  name: string;
  selection_mode: string;
  pog_type: string;
  product_ids: number[];
  option_count: number;
  product_count: number;
  option_group_count: number;
  option_group_ids: number[];
  show: boolean;
  sort_order: number;
  price_list_id: number;
  options: IProductOptionData[];
  product_to_option_group_links?: IProductToOptionGroupLinkData[];
}

export interface IProductOptionGroupRecord {
  id: number;
  matched: List<ProductOptionGroupRecord>;
  uuid: string;
  match_id: string;
  name: string;
  selection_mode: string;
  pog_type: string;
  product_ids: List<number>;
  option_count: number;
  product_count: number;
  option_group_count: number;
  option_group_ids: List<number>;
  show: boolean;
  sort_order: Nullable<number>;
  price_list_id: number;
  option_ids: List<number>;
}

const defaultProductOptionGroupProps: IProductOptionGroupRecord = {
  id: 0,
  matched: List<ProductOptionGroupRecord>(),
  uuid: "",
  match_id: "",
  name: "",
  selection_mode: "",
  // price lists that were activated prior to adding pog_type column are set to "default"
  pog_type: "default",
  product_ids: List<number>(),
  option_count: 0,
  product_count: 0,
  option_group_count: 0,
  option_group_ids: List<number>(),
  show: true,
  sort_order: null,
  price_list_id: 0,
  option_ids: List<number>(),
};

export class ProductOptionGroupRecord
  extends Record(defaultProductOptionGroupProps)
  implements IProductOptionGroupRecord {}
